import { motion } from "framer-motion";
import { ReactNode } from "react";

interface JourneyStepProps {
  step: string; // "01"
  label: string; // "Signal"
  title: ReactNode;
  subhead?: ReactNode;
  tone?: "default" | "muted";
  id?: string;
  children: ReactNode;
}

const JourneyStep = ({ step, label, title, subhead, tone = "default", id, children }: JourneyStepProps) => {
  return (
    <section
      id={id}
      className={`relative py-20 md:py-28 ${tone === "muted" ? "bg-muted/20 border-y border-border" : "bg-background"}`}
    >
      <div className="container mx-auto px-6">
        <motion.div
          initial={{ opacity: 0, y: 16 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          className="mb-12 max-w-3xl"
        >
          <div className="flex items-center gap-3 mb-4">
            <span className="inline-flex items-center justify-center w-9 h-9 rounded-full border border-primary/30 bg-primary/5 text-primary font-display text-sm font-semibold">
              {step}
            </span>
            <span className="text-primary text-xs font-semibold tracking-[0.2em] uppercase">
              Step {step} · {label}
            </span>
          </div>
          <h2 className="font-display text-3xl md:text-4xl lg:text-5xl font-bold leading-tight mb-4">
            {title}
          </h2>
          {subhead && (
            <p className="text-muted-foreground text-base md:text-lg leading-relaxed">{subhead}</p>
          )}
        </motion.div>
        {children}
      </div>
    </section>
  );
};

export default JourneyStep;